import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'agent' | 'user';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = React.memo(({
  children,
  requiredRole
}) => {
  const { isAuthenticated, user, isLoading } = useAuthStore();

  // Show loading while hydrating
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-2 text-gray-600">Đang tải...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/auth/login" replace />;
  }

  // Check role-based access
  if (requiredRole && user.type !== requiredRole) {
    const redirectPath = user.type === 'admin' ? '/admin/dashboard' :
                        user.type === 'agent' ? '/agent/dashboard' :
                        '/user/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  // Allow access
  return <>{children}</>;
});

ProtectedRoute.displayName = 'ProtectedRoute';

export default ProtectedRoute;